// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Modal_modalOverlay__HHfRt","modal":"Modal_modal__Inl4q","modalCloseBtn":"Modal_modalCloseBtn__QJVbE","modalContent":"Modal_modalContent__pVOck"};